﻿document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.code-container').forEach(container => {
        // Create the icon div
        const button = document.createElement('button');
        button.className = 'btn btn-outline-light    btn-sm rounded-1 btn-copy';
        button.textContent = 'Copy';

        // Handle the click event
        button.onclick = function () {
            const code = container.querySelector('code').innerText;
            navigator.clipboard.writeText(code).then(() => {
                // Change text to "Copied!" and then revert after 2 seconds
                button.textContent = 'Copied!';
                button.classList.add('copied');
                setTimeout(() => {
                    button.textContent = 'Copy';
                    button.classList.remove('copied');
                }, 1000);
            });
        };

        // Append the button to the container
        container.appendChild(button);
    });
});